import { memo } from 'react';
import * as S from './ChangedValue.styled';
import { ArrowRighWithLine, UserCircle } from 'assets/icons';
import { CustomTooltip } from 'components';

export const ChangedValue = memo(({ eventType, oldValue, newValue, userName }) => {
  return (
    <S.ChangeContainer>
      {eventType !== 'budget' && eventType !== 'bid' && <S.SmallTitle>Change:</S.SmallTitle>}
      {eventType === 'budget' && <S.SmallTitle>Daily Budget:</S.SmallTitle>}
      {eventType === 'bid' && <S.SmallTitle>Default Bid:</S.SmallTitle>}
      <S.ValuesContainer>
        <S.OldValue>{oldValue}</S.OldValue>
        <ArrowRighWithLine />
        <S.NewValue>{newValue}</S.NewValue>
        <CustomTooltip
          content={<UserCircle />}
          text={<S.SmallTitle>Changed by: {userName}</S.SmallTitle>}
        />
      </S.ValuesContainer>
    </S.ChangeContainer>
  );
});

ChangedValue.displayName = 'ChangedValue';
